import type { DonationMethod } from '../types/donation'

export const donationMethods = new Set<DonationMethod>([
  'e-transfer',
  'deposit',
  'cheque',
  'cash',
])
